import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Rol, Usuario, UsuarioFiltro, UsuarioListResponse, UsuarioStats } from './usuario.model';

@Injectable({ providedIn: 'root' })
export class GestionUsuariosService {

  private readonly API_URL: string = environment.API_URL;

  constructor(private http: HttpClient) {}

  list(filtro: UsuarioFiltro): Observable<UsuarioListResponse> {
    let params = new HttpParams()
      .set('page', String(filtro.page))
      .set('size', String(filtro.size));
    if (filtro.search && filtro.search.trim()) params = params.set('search', filtro.search.trim());
    if (filtro.rolId != null) params = params.set('rolId', String(filtro.rolId));
    if (filtro.activo != null) params = params.set('activo', String(filtro.activo));
    return this.http.get<UsuarioListResponse>(`${this.API_URL}/user/list/paginated`, { params });
  }

  stats(): Observable<UsuarioStats> {
    return this.http.get<UsuarioStats>(`${this.API_URL}/user/stats`);
  }

  listRoles(): Observable<Rol[]> {
    // /rol/list devuelve { message, Rol: [...] } — desenvolvemos aquí.
    return this.http.get<any>(`${this.API_URL}/rol/list`).pipe(
      map((resp) => Array.isArray(resp) ? resp : (resp?.Rol || []))
    );
  }

  create(payload: Partial<Usuario> & { password: string; roles: number[] }): Observable<any> {
    return this.http.post(`${this.API_URL}/user/admin/create`, payload);
  }

  update(id: number, payload: Partial<Usuario>): Observable<any> {
    return this.http.post(`${this.API_URL}/user/admin/update/${id}`, payload);
  }

  updatePassword(id: number, password: string): Observable<any> {
    return this.http.post(`${this.API_URL}/user/${id}/password`, { password });
  }

  setRoles(id: number, roles: number[]): Observable<any> {
    return this.http.put(`${this.API_URL}/user/${id}/roles`, { roles });
  }

  desactivar(id: number): Observable<any> {
    return this.http.post(`${this.API_URL}/user/borrar/${id}`, {});
  }

  reactivar(id: number): Observable<any> {
    return this.http.post(`${this.API_URL}/user/reactivar/${id}`, {});
  }

  forzarConfirmacionEmail(id: number): Observable<any> {
    return this.http.post(`${this.API_URL}/user/${id}/forzar-confirmacion-email`, {});
  }
}
